import { FC } from 'react';
import { MyLink, LinkColors } from '@app/shared';
import { ContentTooltipTypeProps } from './TypeProps';
import classNames from 'classnames';

import styles from './Badges.module.scss';

export const ContentTooltip: FC<ContentTooltipTypeProps> = ({ className, list }) => {
  return (
    <div className={classNames(styles.WrapperContentTooltip, className)}>
      {list.map(item => {
        return (
          <MyLink color={LinkColors.Grey} key={item.href} href={item.href}>
            {item.name}
          </MyLink>
        );
      })}
    </div>
  );
};
